export default __webpack_public_path__ + "static/media/open-positions-2k.752f608d.jpg";